<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <!-- <imgBigCards></imgBigCards> -->
    <!-- 模块1 -->

    <!-- 内容盒子 -->
    <div class="correction-content">
      <!-- 正版验证 -->
      <p class="a-title">正版验证</p>
      <!-- 左边盒子 -->
      <div class="text-input">
        <el-form
          style="max-width: 343px"
          :model="mydata.form"
          :rules="mydata.rules"
          label-width="auto"
          class="demo-ruleForm"
          ref="myForm"
        >
          <el-form-item label="刮卡正版验证码" prop="code">
            <el-input v-model="mydata.form.code" />
          </el-form-item>
        </el-form>
        <p>如何获取正版验证码</p>
        <p>
          可在天利图书的封面封底上找到防伪标签，防伪标签上有涂层，刮开涂层即可获得正版验证码，输入正版验证码时，字母不分大小写且无空格。
        </p>
        <!-- 提交按钮 -->
        <el-button
          type="primary"
          @click="reviewQualificationsStep2Button"
          :loading="mydata.btnLoading"
          >点击验证</el-button
        >
      </div>

      <!-- 中间分割线 -->
      <div class="text-line"></div>

      <!-- 右边二维码盒子 -->
      <div class="text-code">
        <div class="code-box">
          <!-- <img v-complete:src="mydata.oa_qrcode" width="100%"> -->
          <img
            v-complete:src="
              mydata.VUE_APP_BASE_HOST +
              configObj.official_accounts_qrcode?.value
            "
            alt=""
            style="width: 185px; height: 185px"
          />
        </div>
        <p>
          {{ configObj.genuine_verification_oa_qrcode_descr?.value }}
        </p>
        <!-- <p>扫码关注微信公众号</p> 
        <p>后台回复“1” 可另获取 10G高三必备学习资源</p>  -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { ArrowRight } from "@element-plus/icons-vue";
import { ref, reactive, inject } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import imgBigCards from "@/components/imgBigCards/index.vue";
import { checkBook } from "@/api/home/index.js";
import { configFloating } from "@/api/home/index.js";

const router = useRouter();
const myForm = ref(null);

const mydata = reactive({
  size: "default",

  form: {
    code: "",
  },

  rules: {
    code: [
      {
        required: true,
        message: "请刮卡验证码",
      },
    ],
  },
  btnLoading: false,
  oa_qrcode: "",
  codeTitle: "",
  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
});

//正版验证的二维码+提示语
const configObj = inject("configObj");
// console.log('configObj!!!',configObj);

//点击事件
function reviewQualificationsStep2Button() {
  myForm.value.validate((valid, fields) => {
    if (valid) {
      checkBook(mydata.form).then((res) => {
        ElMessage({
          message: res.msg,
          type: "success",
        });
      });
    }
  });
}

//正版验证二维码
function getData() {
  configFloating().then((res) => {
    mydata.oa_qrcode = res.data.oa_qrcode;
    // console.log(res.data,"正版验证")
  });
}

getData();
</script>

<style scoped lang="scss">
.books-details {
  // background-color: #f9f9f9;
  // overflow: hidden;
  // border: 1px solid red;
  // padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //内容盒子
  .correction-content {
    margin: 0 auto;
    padding: 16px 16px 40px 16px;
    background-color: #ffffff;
    // box-shadow: 0px 5px 40px 0px #0000000d;
    // border-radius: 8px;
    // border: 1px solid blue;
    /////  标题  （正版验证）
    .a-title {
      border-left: 4px solid #009de0;
      font-size: 18px;
      font-weight: 700;
      color: #333333;
      padding-left: 10px;
      margin-bottom: 20px;
    }

    ////// 左边盒子 ////////////////////////////////////
    .text-input {
      // width: 515px;
      // height: 822px;
      // border: 1px solid blue;

      overflow: hidden;

      //输入框的长度（包括字体）
      :deep(.el-form-item.is-required.asterisk-left) {
        width: 343px;
        margin-bottom: 20px;
        // height:32px;
        // border:1px solid blue;
        display: flex;
        flex-direction: column;

        //字体
        .el-form-item__label {
          color: #000000;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 1px;

        }

        .el-input{
          height:40px;
        }
      }
      //如何获取正版验证码 字体
      > p:nth-of-type(1) {
        font-size: 14px;
        font-weight: 400;
        color: #ff0000;
        line-height: 22px;
        margin-top: 12px;
        // margin-left: 129px;
      }
      //如何获取正版验证码 内容
      > p:nth-of-type(2) {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
        // margin-left: 129px;
      }

      ////// 按钮
      :deep(.el-button.el-button--primary) {
        width: 240px;
        height: 40px;
        border-radius: 8px;
        display:block;
        margin:0 auto;
        margin-top: 30px;
        // margin-left: 129px;

        > span {
          font-size: 14px;
          font-weight: 400;
        }
      }
    }

    ////// 中间分割线
    // .text-line {
    //   width: 1px;
    //   height: 100%;
    //   background-color: #dcdee2;
    // }

    //////右边二维码盒子
    .text-code {
      width: 316px;
      height: 232px;
      margin:0 auto;
      margin-top:40px;
      // border: 1px solid red;
      .code-box {
        width: 185px;
        height: 185px;
        margin: 0 auto;

        // border: 1px solid rgb(0, 255, 64);
      }
      > p {
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        line-height: 22px;
      }
      > p:nth-of-type(1) {
        text-align: center;
        margin-top: 20px;
      }
      > p:nth-of-type(2) {
        text-align: center;
      }
    }
  }
}
</style>
